import {getLocationMetaActivity, DispatchTrackingPerformer} from "@ots-frontend/ots-data";
import {MarkerIcon, getDefaultMarkerIcon} from "../marker/Marker/Marker";
import TrailerIcon from "../../../../assets/map/truck_icon.png";
import TrailerStationaryIcon from "../../../../assets/map/truck_stationary_icon.png";
import {defaultMapMarkerColor, gpsRouteColor, siteYardColor} from "../../../theme/colors";

export const TRACKING_MAP_OPTIONS: google.maps.MapOptions = {
  mapTypeId: "satellite",
  disableDefaultUI: true,
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: false
};

export const TRACKING_ROUTE_OPTIONS: google.maps.PolylineOptions = {
  strokeColor: gpsRouteColor,
  strokeOpacity: 0.85,
  strokeWeight: 4
};

export const getTrackingPerformerMarkerIcon = (performer?: DispatchTrackingPerformer): MarkerIcon => {
  return getLocationMetaActivity(performer?.locationContext?.meta)?.status === "IDLE" ? TrailerStationaryIcon : TrailerIcon;
}

export const getTrackingDestinationMarkerIcon = (): MarkerIcon => {
  return getDefaultMarkerIcon(defaultMapMarkerColor);
}

export const getTrackingSourceMarkerIcon = (): MarkerIcon => {
  return getDefaultMarkerIcon(siteYardColor);
}
